<template>
  <div class="container">
    <!-- 标题 -->
    <div class="toptitle">{{ $t('auth').title }}</div>
    <div class="infoss">
      <div class="right">
        <!-- 高级认证 -->
        <div class="title">{{ $t('auth').high }}</div>
        <div class="info">
          <!-- 正面照 -->
          <div class="item">
            <div class="lable">{{ $t('auth').zmz }}</div>
            <div class="up_img">
              <van-uploader :after-read="justAfterRead" :disabled="!ReadonlyFlag">
                <img v-if="ObverseImage" :src="baseUrl + ObverseImage" />
                <van-icon v-else name="plus" color="var(--text_color)" size="50" />
              </van-uploader>
            </div>
          </div>
          <!-- 背面照 -->
          <div class="item">
            <div class="lable">{{ $t('auth').bmz }}</div>
            <div class="up_img">
              <van-uploader :after-read="justAfterRead2" :disabled="!ReadonlyFlag">
                <img v-if="ObverseImage2" :src="baseUrl + ObverseImage2" />
                <van-icon v-else name="plus" color="var(--text_color)" size="50" />
              </van-uploader>
            </div>
          </div>
          <!-- 按钮 -->
          <van-button v-if="ReadonlyFlag" block :loading="btnloading" @click="handleSubHigh">{{ $t('auth').btn
          }}</van-button>
          <div class="tips" v-if="!ReadonlyFlag && (auditStatus == '3' || auditStatus == '4')">{{ AuditStatusMsg
          }}</div>
          <!-- <div class="upbtn" v-if="!ReadonlyFlag && (auditStatus == '3' || auditStatus == '4')" @click="handleUp">
        {{ $t('auth').upbtn }}
      </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
// import PopoverSelect from '@/components/popoverSelect.vue'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    // PopoverSelect,
  },
  data() {
    return {
      btnloading: false,
      baseUrl: window.baseURL,
      ReadonlyFlag: false,//高级认证修改
      BaseReadonlyFlag: false,//初级认证修改
      cardType: 1,
      cardTypeTxt: this.$t('auth').idCard,
      realName: '',
      certificate: '',
      nationality: '',
      ObverseImage: '',
      ObverseImage2: '',
      auditStatus: '',
      AuditStatusMsg: '',
      BaseAuditStatusMsg: '',
    }
  },
  computed: {
    cardTypeActions() {
      return [
        { text: this.$t('auth').idCard, val: 1 },
        { text: this.$t('auth').passport, val: 2 },
        { text: this.$t('auth').driverlicense, val: 3 },
      ]
    },
  },
  mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    window.scrollTo(0, 0);
    this.getMemberAuthInfo()
  },
  methods: {
    //选择证件类型
    async onSelect(action) {
      this.cardType = action.val
      this.cardTypeTxt = action.text
    },
    // 获取认证信息
    async getMemberAuthInfo() {
      const res = await userApi.getMemberAuthInfo()
      const userInfo = res.auth
      if (userInfo.realName) {
        this.realName = userInfo.realName
        this.certificate = userInfo.certificate
        this.nationality = userInfo.nationality
        this.cardTypeTxt = userInfo.authenticationType == 1 ? this.$t('auth').idCard : userInfo.authenticationType == 2 ? this.$t('auth').passport : userInfo.authenticationType == 3 ? this.$t('auth').driverlicense : ''
      }
      if (userInfo.imgs) {
        this.ObverseImage = userInfo.imgs.split(',')[0]
        this.ObverseImage2 = userInfo.imgs.split(',')[1]
      }
      this.BaseAuditStatusMsg = userInfo.auditStatus == '3' ? this.$t('auth').success : userInfo.auditStatus == '5' ? this.$t('auth').fail : userInfo.auditStatus == '4' ? this.$t('auth').success : userInfo.auditStatus == '1' ? this.$t('auth').wait : userInfo.auditStatus == '2' ? this.$t('auth').success : ''
      this.AuditStatusMsg = userInfo.auditStatus == '3' ? this.$t('auth').wait : userInfo.auditStatus == '4' ? this.$t('auth').success : ''
      this.BaseReadonlyFlag = userInfo.auditStatus !== '0'
      this.ReadonlyFlag = userInfo.auditStatus == '2'
      this.auditStatus = userInfo.auditStatus
    },
    // 正面照
    async justAfterRead(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.ObverseImage = res.fileName
    },
    // 背面照
    async justAfterRead2(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.ObverseImage2 = res.fileName
    },
    // 选择国家
    selectCountry(val) {
      if (val.name) {
        this.nationality = val.name
      }
      this.$nextTick(() => {
        const searchInput = document.querySelector(
          '.selectCountry_auth .search-input'
        )
        if (searchInput) {
          searchInput.style.width = '90%'
          searchInput.style.height = 'auto'
        }
      })
    },
    // 高级修改确认
    handleUp() {
      this.$dialog.confirm({
        title: this.$t('auth').upMsg,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.ReadonlyFlag = true
        })
    },
    // 提交高级认证
    async handleSubHigh() {
      if (!this.ObverseImage) {
        this.$toast({ message: this.$t('auth').tips3 })
        return false
      }
      if (!this.ObverseImage2) {
        this.$toast({ message: this.$t('auth').tips4 })
        return false
      }
      const form = {
        imgs: this.ObverseImage + ',' + this.ObverseImage2,
      }
      this.btnloading = true
      await userApi.highAuth(form)
      this.btnloading = false
      this.getMemberAuthInfo()
      this.$toast({ message: this.$t('auth').subMsg })
      this.$router.go(-1)
    },
    // 初级修改确认
    handleUpBase() {
      this.$dialog.confirm({
        title: this.$t('auth').upMsg,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.BaseReadonlyFlag = false
        })
    },
    // 提交初级认证
    async handleSubBase() {
      if (!this.realName.trim()) {
        this.$toast({ message: this.$t('auth').tips1 })
        return false
      }
      if (!this.certificate.trim()) {
        this.$toast({ message: this.$t('auth').tips2 })
        return false
      }
      if (!this.nationality.trim()) {
        this.$toast({ message: this.$t('auth').tipsgj })
        return false
      }
      const form = {
        realName: this.realName,
        certificate: this.certificate,
        nationality: this.nationality,
        authenticationType: this.cardType,
      }
      await userApi.baseAuth(form)
      this.getMemberAuthInfo()
      this.$toast({ message: this.$t('auth').success })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  margin-bottom: -60px;
  width: 100%;
  background: var(--background_color);

  .toptitle {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .infoss {
    margin: 0 auto;
    max-width: 780px;
    display: flex;
    justify-content: space-between;

    .left {
      width: 50%;
      margin-right: 50px;
    }

    .right {
      width: 100%;
    }

    .title {
      margin-top: 30px;
      font-size: 21px;
      font-weight: bold;
      color: var(--text_color);
    }

    .info {
      padding: 20px 0;

      .lable {
        font-size: 15px;
        color: var(--ntext_color);
        margin-bottom: 10px;
      }

      .selbtn {
        background: var(--background_color);
        padding: 0 15px 0 15px;
        border-radius: 10px;
        font-size: 15px;
        color: var(--text_color);
        height: 40px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
      }

      .up_img {
        width: 170px;
        height: 107px;
        border-radius: 10px;
        background: var(--background_color);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        img {
          width: 170px;
          height: 107px;
          border-radius: 10px;
        }
      }

      .tips {
        margin-top: 30px;
        text-align: center;
        font-size: 17px;
        font-weight: bold;
        color: var(--text_color);
      }

      .upbtn {
        margin-top: 20px;
        text-align: center;
        font-size: 13px;
        color: var(--ntext_color);
      }
    }

    .line {
      margin-bottom: 30px;
      height: 10px;
      background: var(--info_color);
    }
  }
}

.vue-country-popover-container {
  width: 100%;
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 14px;
  opacity: 0.9;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 40px;
  margin-bottom: 20px;
  border-radius: 10px;
  font-size: 14px;
  border: 1px solid var(--info_color);

  &:hover {
    border: 1px solid var(--text_color);
  }
}

::v-deep .van-button {
  margin-top: 30px;
  background: var(--text_color);
  height: 40px;
  border-radius: 20px;
  border: 0;
  font-size: 15px;
  color: var(--background_color);
}

::v-deep .van-button:hover {
  opacity: 0.8;
}
</style>
